/* eslint-disable no-case-declarations */
import { Card } from '@mui/material';
import React from 'react';

import ContentLoader from '@components/ContentLoader';

import { COUGH_LOW_DISEASE_LIKELIHOOD } from '@constants/scan';

import { useScanResults } from '@hooks/useScanResults';

import type { ScanResult } from '@models/scan';

import { ScanType } from 'generated/types';

import CoughScanContent from '../Content/CoughScanContent';
import FaceBodyScanContent from '../Content/FaceBodyScanContent';
import SkinScanContent from '../Content/SkinScanContent';

interface ScanCardProps {
  data: ScanResult;
  loading: boolean;
  patientId?: string | null;
}

export default function ScanCard({ data, loading, patientId }: ScanCardProps) {
  const { scan_type } = useScanResults();

  let content: React.ReactNode;
  switch (scan_type) {
    case ScanType.respiratory:
      const disease_likelihoods =
        data.cough_results?.disease_likelihoods.filter(
          ({ likelihood }) => (likelihood ?? 0) >= COUGH_LOW_DISEASE_LIKELIHOOD
        ) ?? [];

      const coughData: ScanResult = {
        ...data,
        cough_results: {
          ...data.cough_results,
          high_infection_risk: data.cough_results?.high_infection_risk ?? false,
          obstructive_cough_pattern:
            data.cough_results?.obstructive_cough_pattern ?? false,
          disease_likelihoods,
        },
      };
      content = <CoughScanContent data={coughData} />;
      break;
    case ScanType.skin:
      content = <SkinScanContent data={data} patientId={patientId} />;
      break;
    case ScanType.body:
    case ScanType.face:
    default:
      content = <FaceBodyScanContent data={data} />;
      break;
  }

  return (
    <Card
      sx={{
        mb: {
          xs: 2,
          md: 0,
        },
      }}
    >
      <ContentLoader loading={loading}>{content}</ContentLoader>
    </Card>
  );
}
